import { STATICS } from 'statics'
import { Button } from 'components/button'
import { useDispatch } from 'react-redux'
import { setDrawer } from 'slices/drawer'
import { DRAWER_KEY } from 'app-constants'
import './style.scss'

export function Success() {
  const dispatch = useDispatch()

  function handleClose() {
    dispatch(setDrawer(DRAWER_KEY.NONE))
  }

  return (
    <div className='container-special-offer-success'>
      <div className='special-offer-content'>
        <div className='content-title'>
          <div className='icon-check-circle'>
            <STATICS.CHECK_CIRCLE />
          </div>
          <span className='title-success'>Tudo certo!</span>
        </div>
        <p>Sua mudança ocorrerá em até 2 dias úteis</p>
        <p>O valor proporcional entre os planos será ajustado na sua próxima fatura.</p>
      </div>
      <Button className='button' color='primary' onClick={handleClose}>
        Ok, entendi!
      </Button>
    </div>
  )
}
